"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _inputRadio = require("@citrus/input-radio");
var _tag = require("@citrus/tag");
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _Tag, _Tag2;
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    scenario = _ref.scenario,
    question = _ref.question,
    selectedIndex = _ref.selectedIndex,
    knockout = _ref.knockout,
    knockoutText = _ref.knockoutText,
    hint = _ref.hint,
    number = _ref.number,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.trueFalse;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderHint)(id, hint), (0, _PctyQuestionBuilder.renderScenario)(id, scenario), (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), /*#__PURE__*/_react.default.createElement(_inputRadio.Radio, {
    columns: 1,
    disabled: true,
    id: id,
    labelAddOn: function labelAddOn() {
      return (0, _PctyQuestionBuilder.renderKnockout)(id, knockout, knockoutText);
    },
    onChange: function onChange() {}
  }, /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
    value: "True"
  }, "True ", selectedIndex === 0 ? _Tag || (_Tag = /*#__PURE__*/_react.default.createElement(_tag.Tag, {
    type: "positive",
    value: "Correct"
  })) : ''), /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
    value: "False"
  }, "False ", selectedIndex === 1 ? _Tag2 || (_Tag2 = /*#__PURE__*/_react.default.createElement(_tag.Tag, {
    type: "positive",
    value: "Correct"
  })) : '')));
};
var _default = exports.default = Presentational;